import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {SolutionService} from '../../../Services/solution.service';
import {Solution} from '../../../Models/Solution';
import {Helper} from '../../../../helpers/helper.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-view-solution',
  templateUrl: './view-solution.component.html',
  styleUrls: ['./view-solution.component.scss']
})
export class ViewSolutionComponent implements OnInit, OnDestroy {
  public solutionId: number;
  public solution: Solution = new Solution();
  private subscriptions: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private solutionService: SolutionService
  ) {
  }

  ngOnInit() {
    this.subscriptions.push(
      this.route.params.subscribe(params => {
        if (Helper.isDefined(params['id'])) {
          this.solutionId = params['id'];
          this.solutionService.fetchSolutionComplete(this.solutionId);
        }
      })
    );
    this.subscriptions.push(
      this.solutionService.solution.subscribe(solution => {
        this.solution = solution;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
